import { DownOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps, Space } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { sample2ViewStore as store } from "./Sample2ViewStore";

export const UpdateColumnButton: React.FC = observer(() => {
  const items: MenuProps["items"] = [
    {
      label: "Выбрать активные POMs",
      key: "all",
      disabled: !store.canSelectAll,
      onClick: () => store.changeSelect("allPossible"),
    },
    {
      label: "Сбросить выбор",
      key: "empty",
      disabled: !store.canSelectEmpty,
      onClick: () => store.changeSelect("empty"),
    },
  ];
  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Space style={{ cursor: "pointer" }}>
        Update
        <DownOutlined />
      </Space>
    </Dropdown>
  );
});
